import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import * as _ from 'lodash';
import {ApiResponse, AuthService, BaseService, User} from '@hassel-it/angular-common';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PriceRobotReport, PriceRobotReportInterface} from "./price-robot-report";
import {UserInterface} from "@hassel-it/angular-common/lib/service/user";

@Injectable()
export class PriceRobotUsersService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    buildParameters(options: any): HttpParams {
        return new HttpParams();
    }

    getUsers(page: number = 1, options: any): Promise<any> {
        this.reloadHeaders();
        let params = this.buildParameters(options);
        params = params.set('page', <any>page);

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/users', {
            params: params,
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            const results = _.chain(response.data).map((json: UserInterface): User => {
                return User.fromJSON(json)
            }).value();
            return new ApiResponse(results, response.count as number);
        }).catch(PriceRobotUsersService.handleError);
    }
}
